module.exports = __webpack_public_path__ + "img/boton_diagnocat.1c99009d.svg";